import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid } from '@web/utils';
import { AdminDictionaryCategoryBoxDataSourceService } from '../../services/admin-dictionary-category-box-data-source.service';
import { Observable } from 'rxjs';
import { DictionaryDetailsForm } from '../../../shared/models/dictionary-details-form';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { DictionaryDetailsFormComponent } from '../../../shared/containers/dictionary-details-form/dictionary-details-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';

@Component({
  selector: 'app-dictionary-box-category-edit',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    DictionaryDetailsFormComponent,
    AlertsComponent,
  ],
  templateUrl: './admin-dictionary-box-category-edit.component.html',
  styleUrl: './admin-dictionary-box-category-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminDictionaryBoxCategoryEditComponent {
  /* prettier-ignore */
  private readonly adminDictionaryDataSource = inject(AdminDictionaryCategoryBoxDataSourceService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly id = input.required<Guid>();
  public readonly submitSuccessEvent = output();

  protected data$!: Observable<DictionaryDetailsForm>;

  private readonly destroyRef = inject(DestroyRef);

  public constructor() {
    effect(() => this.configureDataSource());
  }

  public handleSubmitClickEvent(data: DictionaryDetailsForm): void {
    this.adminDictionaryDataSource
      .updateByFormData(this.id(), data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.submitSuccessEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private configureDataSource(): void {
    this.data$ = this.adminDictionaryDataSource.fetchDetailsFormById(this.id());
    this.changeDetectorRef.detectChanges();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
